// extracted by mini-css-extract-plugin
export default {"button":"MediumButton_button__6sxED","styleClear":"MediumButton_styleClear__wDvmc","stylePrimary":"MediumButton_stylePrimary__95Gl8","styleDelete":"MediumButton_styleDelete__LVSIT"};